import { oneOf, string } from 'prop-types';
import React, { Fragment } from 'react';
import Head from 'next/head';
import { SITE_NAME } from 'constants/site';
import { AMP_FB_APP_ID } from 'constants/vendor';
import Comment from '../Icons/Comment';
import { sharedPalette } from 'styles/colors/constants';

const SOCIAL_PARAMS = [
  'system',
  'email',
  'facebook',
  'linkedin',
  'pinterest',
  'tumblr',
  'twitter',
  'whatsapp',
  'line',
  'sms',
  'comments'
];

function setParams(type, paramsObj = {}) {
  const { media, resourceId, text, title, url } = paramsObj;
  let additionalParams;

  switch (type) {
    case 'email':
      additionalParams = {
        'data-param-subject': title && `${SITE_NAME}: ${title}`,
        // TODO: Do we want utm tracking on the email url?
        'data-param-body': `Read it at ${url}`
      };
      break;
    case 'facebook':
      additionalParams = {
        'data-param-app_id': AMP_FB_APP_ID,
        'data-param-href': url,
        'data-param-quote': text && text
      };
      break;
    case 'pinterest':
      additionalParams = {
        'data-param-media': media && media,
        'data-param-url': url
      };
      break;
    case 'comments':
      additionalParams = {
        href: `${url}#comments-${resourceId}`
      };
      break;
    default:
      additionalParams = {};
  }

  return additionalParams;
}

function AmpSocialShare(props) {
  const { media, resourceId, title, type, url } = props;
  const params = setParams(type, {
    media,
    resourceId,
    title,
    url
  });

  return (
    <Fragment>
      <Head>
        <script
          key="amp-social-share"
          async
          custom-element="amp-social-share"
          src="https://cdn.ampproject.org/v0/amp-social-share-0.1.js"
        />
      </Head>
      {type === 'comments' && (
        // Must be a standard link, otherwise the link will fail when served
        // from Google's cache - "Accelerated Mobile Pages: Can't open page"
        <a
          className={`AmpSocialShare AmpSocialShare--${type}`}
          href={params.href}
          aria-label="Comments"
        >
          <div className="AmpSocialShare__icon">
            <Comment />
          </div>
        </a>
      )}
      {type !== 'comments' && (
        <amp-social-share
          className={`AmpSocialShare AmpSocialShare--${type}`}
          type={type}
          width="40"
          height="40"
          {...params}
          aria-label={`${type} share button`}
        />
      )}
      <style jsx>{`
        amp-social-share {
          background-color: ${sharedPalette.watermelon};
        }
        /* Need to use tag selector for specificity */
        amp-social-share,
        .AmpSocialShare--comments {
          border-radius: 20px;
          background-position: center center;
          background-size: 80%;
        }

        .AmpSocialShare__icon {
          font-size: 1.5rem;
        }

        .AmpSocialShare--comments {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: ${sharedPalette.watermelon};
          color: #fff;
        }
      `}</style>
    </Fragment>
  );
}

AmpSocialShare.propTypes = {
  media: string,
  resourceId: string,
  title: string,
  type: oneOf(SOCIAL_PARAMS).isRequired,
  url: string.isRequired
};

AmpSocialShare.defaultProps = {
  media: undefined,
  resourceId: undefined,
  title: undefined
};

export default AmpSocialShare;
